function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.999999 2.5C0.999999 1.11929 2.11929 -9.2637e-08 3.5 -1.5299e-07C3.77614 -1.6506e-07 4 0.223858 4 0.5C4 0.776142 3.77614 1 3.5 1C2.67157 1 2 1.67157 2 2.5C2 2.77614 1.77614 3 1.5 3C1.22386 3 0.999999 2.77614 0.999999 2.5Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M2 4.5L2 6.5C2 6.77614 1.77614 7 1.5 7C1.22386 7 1 6.77614 0.999999 6.5L0.999999 4.5C0.999999 4.22386 1.22386 4 1.5 4C1.77614 4 2 4.22386 2 4.5Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M6.5 -2.84124e-07L8.5 -3.71547e-07C8.77614 -3.83617e-07 9 0.223857 9 0.5C9 0.776142 8.77614 1 8.5 1L6.5 1C6.22386 1 6 0.776142 6 0.5C6 0.223858 6.22386 -2.72053e-07 6.5 -2.84124e-07Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M11.5 -5.02681e-07L13.5 -5.90104e-07C13.7761 -6.02174e-07 14 0.223857 14 0.499999C14 0.776142 13.7761 0.999999 13.5 0.999999L11.5 0.999999C11.2239 1 11 0.776142 11 0.5C11 0.223857 11.2239 -4.9061e-07 11.5 -5.02681e-07Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M16.5 -7.21238e-07C17.8807 -7.81591e-07 19 1.11929 19 2.5C19 2.77614 18.7761 3 18.5 3C18.2239 3 18 2.77614 18 2.5C18 1.67157 17.3284 0.999999 16.5 0.999999C16.2239 0.999999 16 0.776141 16 0.499999C16 0.223857 16.2239 -7.09167e-07 16.5 -7.21238e-07Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M19 4.5L19 6.5C19 6.77614 18.7761 7 18.5 7C18.2239 7 18 6.77614 18 6.5L18 4.5C18 4.22386 18.2239 4 18.5 4C18.7761 4 19 4.22386 19 4.5Z",
  fill: "white"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M0.5 9L19.5 9C19.7761 9 20 9.22386 20 9.5C20 9.77614 19.7761 10 19.5 10L0.5 10C0.223857 10 -3.59476e-07 9.77614 -3.71547e-07 9.5C-3.83617e-07 9.22386 0.223857 9 0.5 9Z",
  fill: "white"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M2 12.5L2 15.5C2 16.3284 2.67157 17 3.5 17L16.5 17C17.3284 17 18 16.3284 18 15.5L18 12.5C18 12.2239 18.2239 12 18.5 12C18.7761 12 19 12.2239 19 12.5L19 15.5C19 16.8807 17.8807 18 16.5 18L3.5 18C2.11929 18 1 16.8807 1 15.5L1 12.5C1 12.2239 1.22386 12 1.5 12C1.77614 12 2 12.2239 2 12.5Z",
  fill: "white"
});

function SvgFlipVertical(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlipVertical);
export default __webpack_public_path__ + "static/media/flip-vertical.a5ff4364.svg";
export { ForwardRef as ReactComponent };